import React from 'react';

/**
 * StylesheetPanel component for GuiBuilder
 * CSS editor for custom stylesheet overrides
 */
export default function StylesheetPanel({ customCss, setCustomCss }) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', height: '100%' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                <h4 style={{ 
                    fontSize: '0.8rem', 
                    fontWeight: 700, 
                    textTransform: 'uppercase', 
                    letterSpacing: '0.05em', 
                    color: 'var(--text-secondary)', 
                    margin: 0 
                }}>
                    Custom CSS Overrides
                </h4>
                <span style={{ fontSize: '0.7rem', color: 'var(--text-secondary)', lineHeight: 1.3 }}>
                    Apply stylesheet rules to select inputs, headers, description text, buttons, and summary lists.
                </span>
            </div>
            <textarea
                className="textarea-field"
                style={{
                    fontFamily: 'Consolas, monospace',
                    fontSize: '0.8rem',
                    flex: 1,
                    minHeight: '350px',
                    background: 'var(--bg-primary)',
                    border: '1px solid var(--border)',
                    color: 'var(--text-primary)',
                    padding: '0.75rem',
                    lineHeight: 1.4,
                    resize: 'vertical'
                }}
                value={customCss}
                onChange={e => setCustomCss(e.target.value)}
            />
        </div>
    );
}
